import { FormattedMessage } from "react-intl";

import { Card } from "common/core/card";
import { Heading, Paragraph } from "common/core/typography";
import IDScan from "assets/images/signer/id-scan.svg";

import Styles from "./index.module.scss";

export function EmptyState() {
  return (
    <Card fullWidth containerClassName={Styles.container}>
      <img src={IDScan} alt="" />
      <Heading textStyle="headingFour" level="h3">
        <FormattedMessage
          id="68dc1d35-5925-49b7-a9d4-f3e0870c0015"
          defaultMessage="Check back later..."
        />
      </Heading>
      <Paragraph>
        <FormattedMessage
          id="d53d4aee-ddfa-4159-998e-07e7644a4fc6"
          defaultMessage="Identity information appears here after completion of the verification process."
        />
      </Paragraph>
    </Card>
  );
}
